import { memo, useMemo } from 'react';
import batteryIcon from '../../assets/images/batteryIcon.png';
import userIcon from '../../assets/images/userIcon.png';
import check from '../../assets/images/check.png';
import transactionIcon from '../../assets/images/receiptIcon.png';
import promotionIcon from '../../assets/images/png_icon_announcement_light.png'
import pdfLogo from '../../assets/images/pdfIcon.svg'
import docLogo from '../../assets/images/wordIcon.svg'
import styles from '../Phone/Phone.module.css';
import { ArrowLeftOutlined, EllipsisOutlined, RightOutlined, SignalFilled } from '@ant-design/icons';
import { Col, Flex, Image, Row } from 'antd';

const bgColor = {
    green: '#0080003b',
    blue: '#007bff9e',
    yellow: '#ffc107',
    red: '#ff00005c',
    grey: '#8080803d'
}

function Phone({phoneProps: {imageURL, msgType, buttons, table, header, headerMessage, subHeaderMessage, subFooterMessage, textMsg, fileMsg, OAName}}) {
    const rederFigureTableList = useMemo(() => {
        let result = null;
        if(table) {
            result = table.map((obj, indexField) => (
                <Row key={indexField} style={{margin: '2px 0'}}>
                    <Col span={8} style={{fontSize: 10}}>{obj.key}:</Col>
                    <Col span={16}>
                        <Flex align="center" justify="flex-start">
                            <div style={{fontSize: 10, 
                                        borderRadius: 6,
                                        wordBreak: 'break-all',
                                        padding: (obj.style && '0px 10px'),
                                        color: obj.style,
                                        backgroundColor: bgColor[obj.style]}}> 
                                {obj.value}
                            </div>
                        </Flex>
                    </Col>
                </Row>
            ))
        }
        return result;
    }, [table])
    const renderBtns = useMemo(() => {
        let result = null; 
        if(buttons) {
            result = buttons.map((obj ,index)=> (
                <Flex align='center' className={styles.btnLink} key={index}>
                    <div className={styles.imgBtnLink}>
                        <Image width={35} height={35} src={obj.image[0].url} alt='Ảnh' preview={false} />
                    </div>
                    <div style={{width: 180, fontSize: 11}}>{obj.title}</div>
                    <div className={styles.arrowBtnLink}> <RightOutlined/></div>
                </Flex>
            ))
        }
        return result;
    },[buttons])
    const normal = () => {
        if(fileMsg)
            return (
            <Flex align='center'>
                <div className={styles.logoFile}>
                    <Image width='80%' src={(fileMsg.name.endsWith('pdf')? pdfLogo: docLogo)} alt='Anh' preview={false} />
                </div>
                <Flex vertical className={styles.fileContent} align='start' justify='space-between'>
                    <h4 style={{margin: 2}}>{fileMsg.name}</h4>
                    <p style={{margin: 2}}>{fileMsg.name.split('.').pop().toUpperCase()} - 4.9MB</p>
                </Flex>
            </Flex>
        )
        return textMsg;
    }
    const template = () => {
        return (
            <>
               {headerMessage.content && <div style={{fontWeight: 'bolder', textAlign: headerMessage.align}}>{headerMessage.content}</div>}
               {subHeaderMessage.content && <div style={{marginBottom: 3, textAlign: subHeaderMessage.align, fontSize: 10}}>{subHeaderMessage.content}</div>}
               {rederFigureTableList}
               {subFooterMessage.content && <div style={{marginBottom: 5, textAlign: subFooterMessage.align, fontSize: 11}}>{subFooterMessage.content}</div>}
            </>
        )
    }
    const headerIcon = { transactionIcon, promotionIcon}
    const functions = {normal, template}
   

    return (
        <>
            <div className={styles.phone}>
                <header className={styles.headerPhone} >
                    <Flex className={styles.statusPhone} justify='space-between' align='center'>
                            <SignalFilled style={{fontSize: '15px'}}/>
                            <span>{(new Date()).toLocaleTimeString('en-US', {hour12: true, hour: 'numeric', minute: '2-digit'})}</span>
                            <Image src={batteryIcon} width='9%' alt='Logo' preview={false}/>
                    </Flex>
                    <Flex className={styles.statusPage} justify='space-between' align='center'>
                        <span>
                            <ArrowLeftOutlined style={{fontSize: 18}}/>
                        </span>
                        <span style={{fontWeight: 'bold', textAlign: 'center'}}>
                            {OAName? OAName :"Zalo Official Account"}
                            <Image style={{marginLeft: 2}} src={check} width='5%' alt='Logo' preview={false}/>
                        </span>
                        <span>
                            <EllipsisOutlined style={{fontSize: 19}}/>
                        </span>
                    </Flex>
                </header>
                <div className={styles.bodyPhone}>
                    <div style={{textAlign: 'left'}}>
                        <Image src={userIcon} width='6%' alt='Logo' preview={false}/>
                    </div>
                    <div className={styles.contentMessageAndImg}>
                        {imageURL && (<Image width='100%' src={imageURL} alt='Anh' preview={false} />)}
                        {msgType === 'template'?(
                            <div style={{ backgroundColor:'#efefef', width: "fit-content", borderRadius: 5, margin: '5px 10px', padding: '2px 5px', border: '1px solid #333', display: 'flex', alignItems: 'center'}}> 
                                <img width='14px' height='14px' src={headerIcon[header.iconType]} alt='Anh'/>
                                <span style={{fontWeight: 'bold', fontSize: 9.5, marginLeft: 6, letterSpacing: 0.5}}>{header.content}</span>
                            </div>
                        ): null}
                        <div className={styles.contentMessage}>
                            {functions[msgType]()}
                        </div>
                        {renderBtns}
                    </div>
                </div>
            </div>
        </>
    )
}

export default memo(Phone);